/**
 * Default generic store configuration.
 * All coordinates, contact numbers, and branding strings are fictitious demo placeholders.
 */

export const DEFAULT_STORE_CONFIG = Object.freeze({
  storeId: 'auto-demo-store-01',
  name: 'AutoExpress Maroc',
  tagline: {
    fr: 'Accessoires et équipements automobiles de qualité',
    ar: 'إكسسوارات ومعدات سيارات عالية الجودة',
  },
  description: {
    fr: 'Boutique en ligne spécialisée dans les pièces et accessoires automobiles au Maroc avec paiement sécurisé à la livraison.',
    ar: 'متجر إلكتروني متخصص في قطع غيار وإكسسوارات السيارات في المغرب مع الدفع عند الاستلام.',
  },
  logoUrl: '/images/logo.svg',
  logoWhiteUrl: '/images/logo-white.svg',
  
  // Regional & Currency
  currency: 'MAD',
  country: 'MA',
  defaultLanguage: 'fr',
  supportedLanguages: ['fr', 'ar'],
  locales: {
    fr: 'fr-MA',
    ar: 'ar-MA',
  },

  // Fictitious Contact Information
  contact: Object.freeze({
    phone: '+212 5 22 00 00 00',
    whatsapp: '+212 6 00 00 00 00',
    email: 'contact@demo-autoexpress.ma',
    address: 'Zone Industrielle Sidi Maârouf, Casablanca, Maroc',
    workingHours: {
      fr: 'Lun - Sam : 09:00 - 19:00',
      ar: 'الإثنين - السبت: 09:00 - 19:00',
    },
  }),

  // Payment & Delivery (COD only)
  payment: Object.freeze({
    cashOnDelivery: true,
    onlinePayment: false,
    defaultMethod: 'cod',
    allowedMethods: ['cod'],
  }),

  shipping: Object.freeze({
    freeShippingThresholdCents: 0, // Free shipping for all by default
    defaultShippingCostCents: 0,
    estimatedDeliveryDaysMin: 1,
    estimatedDeliveryDaysMax: 3,
  }),

  order: Object.freeze({
    prefix: 'CMD',
    minQuantity: 1,
    maxQuantity: 10,
  }),

  // Feature Flags
  modules: Object.freeze({
    quickOrder: true,
    vehicleCompatibility: true,
    whatsappAutomation: true,
    newsletter: true,
    stockManagement: true,
  }),

  // Visual Theme Tokens
  theme: Object.freeze({
    primaryColor: '#0f766e', // Modern Teal
    accentColor: '#f97316', // Orange
    surfaceColor: '#ffffff',
    backgroundColor: '#f8fafc',
    textColor: '#0f172a',
  }),
});

/**
 * Returns a sanitized copy of the store configuration safe for public exposure.
 *
 * @param {object} [customConfig]
 * @returns {object}
 */
export function getPublicStoreConfig(customConfig = {}) {
  const merged = { ...DEFAULT_STORE_CONFIG, ...customConfig };
  
  // Ensure no secret properties can ever leak
  return Object.freeze({
    storeId: merged.storeId,
    name: merged.name,
    tagline: merged.tagline,
    description: merged.description,
    logoUrl: merged.logoUrl,
    logoWhiteUrl: merged.logoWhiteUrl,
    currency: merged.currency,
    country: merged.country,
    defaultLanguage: merged.defaultLanguage,
    supportedLanguages: merged.supportedLanguages,
    locales: merged.locales,
    contact: merged.contact,
    payment: merged.payment,
    shipping: merged.shipping,
    order: merged.order,
    modules: merged.modules,
    theme: merged.theme,
  });
}
